import styled from 'react-emotion';
import BaseButton from '../BaseButton/BaseButton';

export const RoundButtonWrapper = styled(BaseButton)`
  border-radius: 100%;
`;
